// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cEF6","option":"styles_option__3d_rh","active":"styles_active__NSk6Y"};